export default __webpack_public_path__ + "static/media/deirezor.902e3488.jpg";